function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Loading from 'swag-client-common/components/info/loading';
import OrderItem from 'swag-client-common/components/partials/cart/cart-item';
import RelatedItemsSummary from 'swag-client-common/components/partials/related-items-summary';
import { getRelatedItemsPricing } from 'swag-common/business-logic';
import { DesignUploadMode } from 'swag-common/interfaces';
import { getImageOfItem } from '../../../../../../redux/cart/cart.utils';
import ItemsBlockWrapper from '../items-block-wrapper';
import { getProps } from './get-wrapper-props/get-props';
import classes from './related-order-item-list.scss';
const styles = {
  loading: {
    position: 'absolute'
  }
};
const RelatedOrderItemList = ({
  items,
  selectedItem,
  isLoading,
  isCart,
  onMoveToDraft,
  onMoveToCart,
  onRemoveItem,
  onEditRequest,
  onEditSizeOfSample,
  onClickMockup,
  onShareClick,
  onProductionTimeClick,
  onProductionTimeChange,
  onSizeClick,
  onQuantityClick
}) => {
  const firstItem = items[0];
  const {
    total,
    setupFee,
    oldSetupFee
  } = getRelatedItemsPricing(items);
  const moveAction = isCart ? onMoveToDraft : onMoveToCart;
  return /*#__PURE__*/React.createElement("div", {
    key: firstItem._id,
    className: classes.container,
    "data-related-container": firstItem._id
  }, isLoading && selectedItem === firstItem._id && /*#__PURE__*/React.createElement(Loading, {
    className: classes.loading,
    style: styles.loading
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.header
  }, /*#__PURE__*/React.createElement("p", null, "Associated products"), /*#__PURE__*/React.createElement("p", {
    className: classes.action
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    onClick: () => moveAction(firstItem._id),
    "data-button": isCart ? 'MoveAssociatedToDraft' : 'MoveAssociatedToCart'
  }, isCart ? 'Save for later' : 'Add to cart')), items.map((relatedItem, index) => /*#__PURE__*/React.createElement(ItemsBlockWrapper, _extends({
    key: relatedItem._id
  }, getProps(items.length, index)), /*#__PURE__*/React.createElement(OrderItem, {
    itemLogoSrc: getImageOfItem(relatedItem),
    index: index,
    item: relatedItem,
    removeItem: onRemoveItem,
    onEditRequest: onEditRequest,
    onEditSizeOfSample: onEditSizeOfSample,
    onClickMockup: onClickMockup,
    moveToDraft: onMoveToDraft,
    onShareClick: onShareClick,
    onProductionTimeClick: onProductionTimeClick,
    onProductionTimeChange: onProductionTimeChange,
    onSizeClick: onSizeClick,
    isFullDesign: relatedItem.prod.designUploadMode === DesignUploadMode.fullDesign,
    onQuantityClick: onQuantityClick,
    isLoading: isLoading,
    selectedItem: selectedItem,
    isSavedForLater: !isCart,
    isInRelatedItemsList: true,
    isRemoveAvailable: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.summaryContainer
  }, /*#__PURE__*/React.createElement(RelatedItemsSummary, {
    total: total,
    setupFee: setupFee,
    oldSetupFee: oldSetupFee,
    wrapperClassName: classes.summaryWrapper
  })));
};
export default RelatedOrderItemList;